import { observer } from "mobx-react-lite";
import { Box, Button, Center, Flex, FlexProps, useRadioGroup } from "@chakra-ui/react";

import { ISetPathOptions } from "@noli/core";
import {
  langStore,
  translate,
  toolbarStore,
  undoBrush,
  redoBrush,
  updateBrushOptions,
} from "@noli/business";

import { PathEditorPanel } from "./common";
import { importantColors } from "@/utils/constants";
import { statusStore, switchLandscapeMode, switchLandscapeType } from "@/stores/status";
// import Button from "@/components/Button";
import SubEditorPanel from "@/components/SubPanel/SubEditor";
import { Editor_Words } from "@/utils/lang/editor";
import React from "react";
import { RadioTag } from "@/components/Radio/RadioTag";

const options = Object.keys(importantColors);

const LandscapeEditor: React.FC<FlexProps> = (props) => {
  const lang = langStore.tgt;
  const numPaths = toolbarStore.numBrushPaths;
  const allOptions = toolbarStore.allBrushOptions;
  const inLandscapeMode = statusStore.inLandscapeMode;
  const { getRootProps, getRadioProps } = useRadioGroup({
    value: statusStore.landscapeType,
    onChange: handleSwitchType,
  });

  function handleSwitchType(type: string) {
    switchLandscapeType(type);
  }

  if (!inLandscapeMode || !Array.isArray(allOptions) || allOptions.length === 0) {
    return null;
  }

  const currentIdx = allOptions.length - (numPaths === 0 || numPaths === allOptions.length ? 1 : 2);
  const currentOption = allOptions[currentIdx];
  const { fill, stroke, width, linecap } = currentOption;

  const setOpt = (opt: ISetPathOptions): void => {
    const full = { fill, stroke, width, linecap, ...opt, index: currentIdx };
    updateBrushOptions(full);
  };

  return (
    <Box w="100%">
      <PathEditorPanel
        alias=".landscape."
        {...props}
        lang={lang}
        options={currentOption}
        setWidth={() => (width) => setOpt({ width })}
        setUseFill={(use) => setOpt({ fill: use ? stroke : "none" })}
      />
      <SubEditorPanel mt="16px" panelTitle={translate(Editor_Words["landscape-types"], lang)}>
        <Center>
          <Flex w="70%" p="16px" wrap="wrap" justify="center" {...getRootProps()}>
            {options?.map((type) => {
              const radioProps = getRadioProps({ value: type });

              return (
                <RadioTag key={type} __css={{ h: "24px", marginBottom: "8px" }} {...radioProps}>
                  {translate(`landscape-${type}`, lang)}
                </RadioTag>
              );
            })}
          </Flex>
        </Center>
      </SubEditorPanel>
      <Center mt="16px">
        <Button w="37.5%" onClick={undoBrush} disabled={toolbarStore.numBrushPaths === 0}>
          {translate("undo-brush", lang)}
        </Button>
        <Box w="5%" />
        <Button w="37.5%" onClick={redoBrush} disabled={toolbarStore.numBrushHistory === 0}>
          {translate("redo-brush", lang)}
        </Button>
      </Center>
      <Center mt="16px">
        <Button w="80%" onClick={switchLandscapeMode}>
          {translate("end-brush", lang)}
        </Button>
      </Center>
    </Box>
  );
};

export default observer(LandscapeEditor);
